var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitnessHeartRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9728 5.8286C22.5649 5.03042 21.9744 4.33972 21.2493 3.81259C20.5243 3.28546 19.6852 2.93677 18.8001 2.79482C17.915 2.65287 17.0089 2.72168 16.1553 2.99565C15.3018 3.26962 14.525 3.74103 13.8878 4.3716L12.3218 5.8006L10.7558 4.3716C10.1185 3.74114 9.34146 3.2699 8.48781 2.99616C7.63415 2.72241 6.72796 2.65387 5.84285 2.79612C4.95773 2.93836 4.11864 3.28737 3.39374 3.8148C2.66883 4.34223 2.07855 5.0332 1.67085 5.8316C1.13864 6.88603 0.954815 8.08217 1.14584 9.24775C1.33687 10.4133 1.8929 11.4882 2.73385 12.3176L12.3218 22.2216L21.9098 12.3146C22.7508 11.4852 23.3068 10.4103 23.4979 9.24475C23.6889 8.07917 23.5051 6.88303 22.9728 5.8286V5.8286Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57178 10.9716H8.33978C8.40946 10.9716 8.47779 10.9909 8.53712 11.0275C8.59645 11.064 8.64446 11.1164 8.67578 11.1786L10.4488 14.7246C10.4811 14.7891 10.5314 14.8429 10.5936 14.8795C10.6558 14.9162 10.7272 14.9341 10.7993 14.9311C10.8714 14.9282 10.9411 14.9045 11.0001 14.8629C11.0591 14.8213 11.1048 14.7636 11.1318 14.6966L13.5118 8.74661C13.5388 8.67968 13.5845 8.62195 13.6434 8.58035C13.7024 8.53875 13.7721 8.51505 13.8442 8.51209C13.9163 8.50914 13.9878 8.52705 14.0499 8.56368C14.1121 8.60032 14.1624 8.65411 14.1948 8.71861L15.2218 10.7646C15.2531 10.8269 15.3011 10.8792 15.3604 10.9157C15.4198 10.9523 15.4881 10.9716 15.5578 10.9716H19.0718",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.321777 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessHeartRate);
export default __webpack_public_path__ + "static/media/fitness-heart-rate.f8969eb1f3e7a0207c13a70450ed7293.svg";
export { ForwardRef as ReactComponent };